<div [class]="'sc-chip sc-chip--color' + color">
  <div class="sc-chip__number" *ngIf="number">{{number}}</div>
  <div class="sc-chip__text">
    <ng-content></ng-content>
  </div>
  <div class="sc-chip__close" *ngIf="enableClose">
    <sc-icon icon="close1" size="0_5" (click)="onClose()"></sc-icon>
  </div>
</div>
